import React from 'react';
import FavouriteBtn from '../../atoms/FavouriteBtn/FavouriteBtn';
import LazyPicture from '../../atoms/LazyPicture';
import RouterLink from '../../atoms/RouterLink';
import ScrollAnimation from 'react-animate-on-scroll';
import { injectImageResolution } from '../../../utils';
import { tealiumClickFunc, tealiumMergeClickData } from '../../../utils/tealium';
import { Text } from '@sitecore-jss/sitecore-jss-react';
import { convertDate } from '../../15_Events/Events';
const EventsFeatureCarouselItem = _ref => {
  let {
    activeTopPicks,
    toggleActiveTopPicks,
    url,
    image,
    title,
    objectID,
    category,
    introText,
    datesRange,
    multipleDates,
    lang,
    eventNextAvailableDate,
    eventsAnalytics,
    params,
    ThemeBasedCards
  } = _ref;
  const imgSrc = injectImageResolution(`${image}`, 700, 460);
  const imgSrcMob = injectImageResolution(`${image}`, 460, 460);
  return /*#__PURE__*/React.createElement("div", {
    key: objectID,
    className: "eventsFeatureCarousel__featured-item"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-5 col-lg-5 col-xl-6 eventsFeatureCarousel__featured-image-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "eventsFeatureCarousel__featured-image-wrap"
  }, /*#__PURE__*/React.createElement(RouterLink, {
    openInSameTab: true,
    href: url,
    title: title,
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['bannerClickAnalytics'], params), title)
  }, /*#__PURE__*/React.createElement(LazyPicture, {
    useEmptyPlaceholder: true,
    hover: true
  }, /*#__PURE__*/React.createElement("source", {
    media: "(min-width: 480px)",
    srcSet: imgSrc
  }), /*#__PURE__*/React.createElement("img", {
    className: "eventsFeatureCarousel__featured-image",
    src: imgSrcMob,
    alt: url
  }))))), /*#__PURE__*/React.createElement("div", {
    className: "col-md-0 col-xl-1"
  }), /*#__PURE__*/React.createElement("div", {
    className: "col-md-7 col-lg-6 col-xl-5 eventsFeatureCarousel__featured-info-col"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row flex-md-grow-1"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col-md-10 col-lg-12 d-flex"
  }, /*#__PURE__*/React.createElement("div", {
    className: "eventsFeatureCarousel__info"
  }, /*#__PURE__*/React.createElement("div", {
    className: "eventsFeatureCarousel__text_sight"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.3
  }, category && category.join(' '))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.45
  }, /*#__PURE__*/React.createElement(RouterLink, {
    className: "eventsFeatureCarousel__item-title_link",
    title: 'title',
    href: url,
    linktype: 'internal',
    onClick: () => tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['titleClickAnalytics'], params), title)
  }, /*#__PURE__*/React.createElement(Text, {
    tag: "h2",
    className: 'eventsFeatureCarousel__item-title',
    field: {
      value: title
    }
  }))), /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.6
  }, /*#__PURE__*/React.createElement("p", {
    className: 'eventsFeatureCarousel__text'
  }, introText, " ")), /*#__PURE__*/React.createElement("div", {
    className: "eventsFeatureCarousel__featured-fav-wrapper"
  }, /*#__PURE__*/React.createElement(ScrollAnimation, {
    animateIn: "animate__fadeInUp",
    animateOnce: true,
    duration: 1.4
  }, datesRange && /*#__PURE__*/React.createElement("div", {
    className: "eventsFeatureCarousel-date"
  }, eventNextAvailableDate ? ` ${multipleDates} ${convertDate(eventNextAvailableDate, '', lang)}` : ` ${datesRange}` && convertDate(datesRange.from_formatted, datesRange.from_formatted === datesRange.to_formatted ? '' : datesRange.to_formatted, lang))), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: objectID,
    multiplyButton: true,
    activeListOnSamePage: activeTopPicks,
    componentPrimaryColor: ThemeBasedCards ? "var(--eventsFeatureCarousel-theme-hex-active-color)" : "var(--eventsFeatureCarousel-theme-hex-background-color)",
    componentPrimaryColorActive: "var(--eventsFeatureCarousel-theme-hex-active-color)",
    classes: 'eventsFeatureCarousel__fav-btn eventsFeatureCarousel__fav-btn_desktop',
    analyticsClick: e => {
      tealiumClickFunc(tealiumMergeClickData(eventsAnalytics['addToFavAnalytics'], params), `${e} : ${title}`);
      toggleActiveTopPicks(objectID);
    }
  })))))));
};
export default EventsFeatureCarouselItem;